<template>
  <div class="container">
    <div class="sideNav">
      <div class="logo">
        <div class="name">
          伍幺柒云餐厅
        </div>
        <div class="version">v3.2</div>
      </div>
      <el-menu background-color="#2e3d4c" text-color="#fff" active-text-color="#409EFF" @select="navSelect"
        :default-active="currentNav">
        <template v-for="item in $store.state.menu.menuList">
          <template v-if="!item.subMenu">
            <el-menu-item :index="item.key" :key="item.key">
              <i :class="item.icon" aria-hidden="true" class="menuIcon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>
          <template v-else>
            <el-submenu :index="item.key" :key="item.key" v-if="item.subMenu.length > 0">
              <template slot="title">
                <i :class="item.icon" aria-hidden="true" class="menuIcon"></i>
                <span>{{ item.title }}</span>
              </template>
              <template v-for="subItem in item.subMenu">
                <el-menu-item v-if="!subItem.subMenu" :index="subItem.key" :key="subItem.key">
                  {{ subItem.title }}
                </el-menu-item>
                <el-submenu v-else :index="subItem.key" :key="key">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item v-for="trdItem in subItem.subMenu" :index="trdItem.key" :key="trdItem.key">
                    {{ trdItem.title }}
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </div>
    <div class="main">
      <div class="header">
        <span class="userInfo">
          <i class="el-icon-user-solid" aria-hidden="true" style="margin: 0 0.5rem; font-size: 1rem"></i>
          <span>{{ userName }}</span>
          <span class="separator">|</span>
          <span>{{ $store.state.userInfo.worksiteName }}</span>
          <span class="ex-worksite" v-if="$store.state.userInfo.exWorksites.length > 1">+{{
            $store.state.userInfo.exWorksites.length - 1
          }}</span>
          <span class="separator">|</span>
          <span>{{ $store.getters["userInfo/role"] }}</span>
          <span class="separator">|</span>
          <el-button type="text" @click="updatePassword">修改密码</el-button>
          <span class="separator">|</span>
          <el-button type="text" @click="logout">退出</el-button>
        </span>
      </div>
      <div class="content">
        <el-tabs v-model="currentTab" type="card" @tab-remove="removeTab">
          <el-tab-pane v-for="item in $store.state.tabs.list" :closable="item.title !== '首页'" :key="item.name"
            :label="item.title" :name="item.name" :style="{ 'max-height': paneHeight + 'px' }" style="overflow: auto">
            <component :is="item.component" :ref="item.name" :params="item.params" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <update-password-dialog ref="updPswDialog" />
  </div>
</template>

<script>
import axios from "axios";
import UpdatePasswordDialog from "./UpdatePasswordDialog";

export default {
  data() {
    return {
      isNavCollapse: false,
      currentTab: "",
      paneHeight: 0,
      buildedMenus: []
    };
  },
  created() {
    let userInfo = "";
    try {
      userInfo = JSON.parse(this.$cookies.get("user"));
    } catch (err) {
      // do nothing
    }
    if (!userInfo) {
      this.$router.replace({
        name: "login"
      });
      return;
    } else {
      this.$store.commit("userInfo/update", {
        user: userInfo
      });
      axios.defaults.headers["Authorization"] = "Bearer " + userInfo.token;
    }

    // 请求后台，获取权限菜单列表
    this.$loading();
    axios.post("core/sysMenu/user/allRight").then((res) => {
      let data = res.data;
      if (data.success) {
        let permissionMenu = [];
        let rightMenus = data.data;
        for (let i = 0; i < rightMenus.length; i++) {
          let item = rightMenus[i];
          let menu = {
            parent: item.parent,
            key: item._id,
            icon: item.icon,
            title: item.name,
            component: () => import(`@/views/${item.path}`)
          }
          permissionMenu.push(menu);
        }

        let parentMenus = data.parentMenus;
        for (let i = 0; i < parentMenus.length; i++) {
          let item = parentMenus[i];
          let menu = {
            key: item._id,
            icon: item.icon,
            title: item.name
          }
          if (!item.editAble) {
            menu.component = () => import(`@/views/${item.path}`);
          } else {
            menu.subMenu = [];
          }
          this.buildedMenus.push(menu);
        }

        this.buildMenusHandle(permissionMenu);
        this.$store.commit("menu/update", {
          menuList: this.buildedMenus
        });

        if (this.buildedMenus.length > 0) {
          this.navSelect(this.buildedMenus[0].key);
        }
      } else {
        this.$message.error(data.message);
      }
    }).finally(() => {
      this.$loading().close();
    });
  },
  mounted() {
    this.calculatePaneHeight();
    window.addEventListener("resize", this.calculatePaneHeight);
  },
  methods: {
    navSelect(index) {
      this.$store.dispatch("tabs/open", { name: index });
    },
    removeTab(targetTab) {
      this.$store.commit("tabs/remove", targetTab);
    },
    calculatePaneHeight() {
      const screenHeight = document.body.offsetHeight;
      const headerHeight = 48;
      const tabHeight = 41;
      const padHeight = 16;
      this.paneHeight = screenHeight - headerHeight - tabHeight - padHeight * 3;
    },
    logout() {
      this.$confirm("确定退出吗？", "提示", {
        type: "info"
      })
        .then(() => {
          this.$store.commit("tabs/removeAll");
          this.$cookies.remove("user");
          this.$router.replace({
            name: "login"
          });
        })
    },
    updatePassword() {
      this.$refs.updPswDialog.show();
    },
    buildMenusHandle(menus) {
      for (let m = 0; m < this.buildedMenus.length; m++) {
        let parentMenuId = this.buildedMenus[m].key;
        for (let i = 0; i < menus.length; i++) {
          let menu = menus[i];
          if (menu.parent == parentMenuId) {
            this.buildedMenus[m].subMenu.push(menu);
          }
        }
      }
    }
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.nameZH || "未登录";
    },
    currentNav() {
      return this.currentTab.split("@")[0];
    }
  },
  watch: {
    "$store.state.tabs.currentTab"(val) {
      this.currentTab = val;
    },
    currentTab(val) {
      if (val !== this.$store.state.tabs.currentTab) {
        this.$store.commit("tabs/updateCurrent", val);
      }
    }
  },
  components: {
    UpdatePasswordDialog
  }
};
</script>

<style scoped>
.menuIcon {
  font-size: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
}

.container {
  display: flex;
  height: 100%;
}

.sideNav {
  width: 200px;
  min-width: 200px;
  height: 100%;
  background-color: #2e3d4c;
  overflow-y: scroll;
  overflow-x: hidden;
}

.sideNav .el-menu {
  border-right: none;
}

.main {
  flex-grow: 1;
  overflow: hidden;
}

.header {
  height: 3rem;
  line-height: 3rem;
  box-shadow: 0px 2px 5px #dddddd;
  padding: 0 1rem;
}

.header>.userInfo {
  float: right;
  font-size: 0.8rem;
}

.content {
  padding: 1rem;
}

.separator {
  margin: 0 0.5rem;
  color: #dcdfe6;
}

.ex-worksite {
  color: blue;
}

.logo {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  height: 3rem;
  line-height: 3rem;
  border-bottom: 1px solid #909399;
}

.name {
  font-weight: bold;
  display: flex;
}

.name_517 {
  font-size: 24px;
  line-height: 24px;
  display: flex;
  align-items: center;
  margin-right: 4px;
}

.version {
  background-color: #F56C6C;
  font-size: 12px;
  padding: 0px 6px;
  border-radius: 8px;
  height: 16px;
  line-height: 16px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue